export default __webpack_public_path__ + "static/media/localizacao.01545cda.svg";